module.exports = __webpack_public_path__ + "img/播州区人民医院.51474424.png";